import RfqInformation from "./RfqInformation";

export default RfqInformation;
